import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { AppLayoutComponent } from './core/layout/app-layout/app-layout.component';
import { WebSocketService } from '@core/services/websocket.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [AppLayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'Alienala';
  // Son constructeur et l'effect s'occuperont du reste automatiquement.
  private webSocketService = inject(WebSocketService);

  ngOnInit(): void {
    // L'autorisation Push est demandée depuis une action explicite du manager.
  }
}
